export default __webpack_public_path__ + "static/media/flow.c237baea.png";